import React from 'react';
import {Modal,
ModalHeader,
ModalBody} from 'reactstrap'

class modalPlan extends React.Component {
	constructor(props){
    super(props)
		this.state ={
			payMethod : 'Year',
			selectedMethod : '',
			billing : 0,
			billingExtra : 0,
			extraCaption : 'Select',
			Month : {
				basic  : 4.95,
				level1 : 99.95,
				level2 : 299.95,
				level3 : 599,
				extra  : 2
			},
			Year : {
				basic  : 59.4,
				level1 : 1199.4,
				level2 : 3599.4,
				level3 : 7188,
				extra  : 24,
			}
		}
	}

	componentWillUnmount() {
		this.setState({billing : 0})
	}

	payMethod = (method) => {
		let billingExtra = (this.state.extraCaption !== 'Select')? this.state[method].extra : 0
		let billing = (this.state.selectedMethod)? this.state[method][this.state.selectedMethod] : 0

		this.setState({payMethod : method,billing,billingExtra})
	}

	SelectButton = (plan) => {
		let billing = this.state.billing
		let planing = (this.state.selectedMethod !== plan)&&plan
		if (this.state.selectedMethod === plan){
			billing = this.state.billing - this.state[this.state.payMethod][plan]
		}else{
			billing = this.state[this.state.payMethod][plan]
		}

		this.setState({selectedMethod : planing, billing})
	}
	SelectExtra = () => {
		let billingExtra = this.state.billingExtra
		let text = (this.state.extraCaption === 'Select')? 'Selected' : 'Select'
		if (this.state.extraCaption === 'Select'){
			billingExtra = this.state[this.state.payMethod].extra
		}else{
			billingExtra = this.state.billingExtra - this.state[this.state.payMethod].extra
		}
		this.setState({extraCaption : text, billingExtra})
	}
	
	render() {
		return(
			<Modal isOpen={this.props.ModalState} toggle={() => this.props.CloseModal()} className="modal-lg">
				<ModalHeader toggle={() => this.props.CloseModal()}>Select Plans</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-md-12 m-top-15">
							<div className="row">
								<div className="col-md-12">
									<table className="table">
										<thead >
											<tr>
												<th className="text-center">Features</th>
												<th className="text-center">Basic Plan</th>
												<th className="text-center">Level 1 Plan</th>
												<th className="text-center">Level 2 Plan</th>
												<th className="text-center">Level 3 Plan</th>
												<th className="text-center">EXTRA Plan</th>
											</tr>
										</thead>
										<tbody className="text-center">
											<tr>
												<th className="text-right"> USERS </th>
												<td style={{fontWeight : '1000'}}> 1 </td>
												<td style={{fontWeight : '1000'}}> 5 </td>
												<td style={{fontWeight : '1000'}}> 20 </td>
												<td style={{fontWeight : '1000'}}> 60 </td>
												<td ><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Record data against assets </th>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Photo Upload </th>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Inventory list </th>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Asset status </th>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Document Storage </th>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"> Full Site Access </th>
												<td><i className="fa fa-times text-danger" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-check text-success" /> </td>
												<td><i className="fa fa-times text-danger" /></td>
											</tr>
											<tr>
												<th className="text-right"	> High Quality Aluminium </th>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-check text-success" /> </td>
											</tr>
											<tr>
												<th className="text-right"	> Scratch Proof QR Codes </th>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-times text-danger" /></td>
												<td><i className="fa fa-check text-success" /></td>
											</tr>
											<tr>
												<th className="text-right"	>
												
												 	<div className="dlk-radio btn-group">
												 		<label className="btn btn-default" style={{cursor:'pointer'}}>
											       	<input name="choices[1]" className="form-control" onClick={()=>this.payMethod('Month')} type="radio" defaultChecked="false" />
											       	<i className="fa fa-check"></i> Monthly
										       	</label>
										       	<label className="btn btn-default" style={{cursor:'pointer'}}>
											       	<input name="choices[1]" className="form-control" onClick={()=>this.payMethod('Year')} type="radio" defaultChecked="checked" />
											       	<i className="fa fa-check"></i> Yearly
										       	</label>
										      </div>
												 </th>
												<td style={{fontWeight : '1000'}}>$ {this.state[this.state.payMethod].basic}+gst</td>
												<td style={{fontWeight : '1000'}}>$ {this.state[this.state.payMethod].level1}+gst</td>
												<td style={{fontWeight : '1000'}}>$ {this.state[this.state.payMethod].level2}+gst</td>
												<td style={{fontWeight : '1000'}}>$ {this.state[this.state.payMethod].level3}+gst</td>
												<td style={{fontWeight : '1000'}}>$ {this.state[this.state.payMethod].extra}+gst</td>
											</tr>
											<tr>
												<th className="text-muted text-right"	>&nbsp;</th>
												<td>
												<button 
													type="button" 
													className={(this.state.selectedMethod === 'basic')? 'btn btn-primary' : 'btn btn-default'} 
													onClick={()=>this.SelectButton('basic')}>
														{(this.state.selectedMethod === 'basic')? 'Selected' : 'Select'}
													</button></td>
												<td>
												<button 
													type="button" 
													className={(this.state.selectedMethod === 'level1')? 'btn btn-primary' : 'btn btn-default'} 
													onClick={()=>this.SelectButton('level1')}>
														{(this.state.selectedMethod === 'level1')? 'Selected' : 'Select'}
													</button></td>
												<td>
												<button 
													type="button" 
													className={(this.state.selectedMethod === 'level2')? 'btn btn-primary' : 'btn btn-default'} 
													onClick={()=>this.SelectButton('level2')}>
														{(this.state.selectedMethod === 'level2')? 'Selected' : 'Select'}
													</button></td>
												<td>
												<button 
													type="button" 
													className={(this.state.selectedMethod === 'level3')? 'btn btn-primary' : 'btn btn-default'} 
													onClick={()=>this.SelectButton('level3')}>
														{(this.state.selectedMethod === 'level3')? 'Selected' : 'Select'}
													</button></td>
												<td>
												<button 
													type="button" 
													className={(this.state.extraCaption === 'Selected')? 'btn btn-primary' : 'btn btn-default'}
													onClick={this.SelectExtra}>
														{this.state.extraCaption}
													</button></td>
											</tr>
										</tbody>
									</table>

									
									<div className="row">
										<div className="col-md-6">
											<h3 className="panel-title">
	                      Payment Details
	                    </h3>
										</div>
										<div className="col-md-6 text-right">
	                      Total Billing<h4>${this.state.billing + this.state.billingExtra} / {this.state.payMethod}</h4>
										</div>
									</div>
									<hr/>
									<div className="row">
						        <div className="col-xs-12 col-md-6" style={{borderRight:'1px solid #ebebeb'}}>
					            <div className="panel panel-default">
				                <div className="panel-heading"></div>
				                <div className="panel-body">
			                    <form> {/* role="form" */}
				                    <div className="form-group">
			                        <label htmlFor="cardNumber">
		                            CARD NUMBER</label>
			                        <div className="input-group">
		                            <input type="text" className="form-control" id="cardNumber" placeholder="Valid Card Number"
	                                required />
		                            <span className="input-group-addon"><img src="https://newinnpubwinchelsea.co.uk/wp-content/uploads/2017/02/visa-mastercard-logo-1.jpg" alt="Visa Mastercard" width={75}/></span>
			                        </div>
				                    </div>
				                    <div className="row">
			                        <div className="col-xs-7 col-md-7">
		                            <div className="form-group">
	                                <label htmlFor="expityMonth">
                                    EXPIRED DATE</label>
                                  <div className="row ml-1">
		                                <div className="col-lg-6 p-0">
	                                    <input type="text" className="form-control" id="expityMonth" placeholder="MM" required />
		                                </div>
		                                <div className="col-lg-6 p-0">
	                                    <input type="text" className="form-control" id="expityYear" placeholder="YY" required />
	                                  </div>
	                                </div>
                            		</div>
			                        </div>
			                        <div className="col-xs-5 col-md-5 pull-right">
		                            <div className="form-group">
	                                <label htmlFor="cvCode">
                                    CVV</label>
	                                <input type="password" className="form-control" id="cvCode" placeholder="CVV" required />
		                            </div>
			                        </div>
				                    </div>
			                    </form>
				                </div>
					            </div>
					            <br/>
					            <a href="http://www.jquery2dotnet.com" className="btn btn-success btn-lg btn-block" role="button">Pay</a>
						        </div>
						        
						        <div className="col-xs-12 col-md-6">
						        	<b>Direct Payment Using</b><br/><br/>
						        	<img src="https://www.paypalobjects.com/webstatic/mktg/logo-center/PP_Acceptance_Marks_for_LogoCenter_266x142.png" alt="Paypal" width={150}/>

						        	
						        	<span 
						        	className="text-muted"
						        	style={{    
						        		display: 'block',
										    position: 'absolute',
										    bottom: '10px'}}>
							        		Some Text include about payment and etc
						        	</span>
						        </div>
						    </div>

								</div>
							</div>
						</div>
					</div>
				</ModalBody>
			</Modal>
		)
	}
}

export default modalPlan;



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/billing/modalPlan.js